(function(){
    'use strict'

    angular
    .module('app.centrosCosto')
    .controller('centrosCosto.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiCentrosCosto = 'api/centrosCosto'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
            clienteId:0
        };

        vm.title = 'Centros de Costo';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.clientes = [];

        const promiseClientes = getComboData(vm.clientes, 'api/Clientes', [companiaId], 'Error al obtener los clientes.');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        get();

        function get(){

            $q.all([promiseClientes])
            .then(function(){
                if(vm.id != 0){
                    ApiBaseService.remoteController = apiCentrosCosto;
                    var promise = ApiBaseService.getAll([companiaId, vm.id]);

                    promise
                    .then(function(data){
                        vm.data = data;
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }                
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al obtener los datos: ' + error.data.Message);
                        break;
                }
            });
        };

        function doFormValidations()
        {
            validateSelectProperty('clienteId');
            validateEmailListProperty('correoElectronico');
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();
            
            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiCentrosCosto;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiCentrosCosto;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/centros-costo');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                clienteId:0
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(property){
            if(vm.data[property] == 0){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        function validateEmailListProperty(property){

            let valid = true;
            const emailList = vm.data[property];
            let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            const emails = emailList.replace(/\s/g,'').split(",");

            for (var i = 0; i < emails.length; i++) {
                if( emails[i] == "" || ! regex.test(emails[i])){
                    valid = false;
                    break;
                }
           }
            if(!valid){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        vm.onSelectChanged = function(property){
            validateSelectProperty(property);
        };

    }
})();